import { useRouter } from "next/router";
import SectionLayout from "../_sectionLayout";
import MapaStronyData from "../../../variables/variables";
import Section from "../../../components/Section";
import TranslatedMessage from "../../../components/TranslatedMessage";

export default function MapaStrony(props) {
  const router = useRouter();

  let Miasto = props.miasto;
  let Podatek = props.podatek;

  let propsType;
  let extendedUrl = "/";
  let siteCode = router.query.siteCode;

  if (MapaStronyData.miasta[Miasto].index) {
    propsType = "/";
  } else if (MapaStronyData.miasta[Miasto].witryna) {
    propsType = "/witryna/";
    extendedUrl = "?siteCode=" + siteCode;
  } else {
    propsType = "/" + MapaStronyData.miasta[Miasto].name.url + "/";
  }

  return (
    <SectionLayout miasto={Miasto} podatek={Podatek}>
      <Section>
        <nav className="pd-sitemap">
          <h2 className="pd-sitemap__title">Strony</h2>
          <ul>
            <li>
              <h3 className="pd-sitemap__subtitle">
                <a href={propsType}>Strona Główna</a>
              </h3>
            </li>
            {MapaStronyData.miasta[Miasto].navigation.map((navigation, index) =>
              navigation.submenu.available ? (
                <li key={index}>
                  <h3 className="pd-sitemap__subtitle">
                    <TranslatedMessage id={navigation.translatedMessage} />
                  </h3>

                  <ul>
                    {navigation.submenu.list.map((list, index) => (
                      <li key={index}>
                        {list.submenu ? (
                          <>
                            <h4 className="pd-sitemap__subtitle">
                              <TranslatedMessage id={list.translatedMessage} />
                            </h4>

                            <ul>
                              {list.submenu.map((submenu, index) => (
                                <li key={index}>
                                  <a
                                    href={
                                      propsType +
                                      submenu.shortName +
                                      extendedUrl
                                    }
                                  >
                                    <TranslatedMessage
                                      id={submenu.translatedMessage}
                                    />
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <a href={propsType + list.shortName + extendedUrl}>
                            <TranslatedMessage id={list.translatedMessage} />
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={index}>
                  <h3 className="pd-sitemap__subtitle">
                    <a href={propsType + navigation.shortName + extendedUrl}>
                      <TranslatedMessage id={navigation.translatedMessage} />
                    </a>
                  </h3>
                </li>
              )
            )}

            <li>
              <h3 className="pd-sitemap__subtitle">
                <a href={propsType + "deklaracja-dostepnosci" + extendedUrl}>
                  Deklaracja dostępności
                </a>
              </h3>
            </li>
          </ul>
        </nav>
      </Section>
    </SectionLayout>
  );
}
